<template>
  <div class="banner-form" :style="{ background: `url(${pcBgImg}) center center / cover no-repeat`, height: `${setHeight}px` }">
    <div class="viedo" v-if="viedoFlag">
      <video src="@/assets/video/banner.mp4" muted autoplay loop />
    </div>
    <div class="content">
      <div class="content-left">
        <img v-if="logoSrc" class="logo" :src="logoSrc" alt="" />
        <div v-if="text" class="text">{{ text }}</div>
        <div v-if="title" class="title">
          <slot name="title"></slot>
        </div>
        <div v-if="desc" class="desc">
          <slot name="desc"></slot>
        </div>
      </div>
      <div class="content-right">
        <Form
          v-if="showForm"
          @msg="msg => $emit('msg', msg)"
          @setShowSuccessDialog="setShowSuccessDialog"
          :landingPageName="landingPageName"
          :hasApi="hasApi"
          :title="title"
          :submitText="submitText"
        ></Form>
      </div>
    </div>
    <div class="banner_tabbox" v-if="bannerTabbox">
      <div class="tab_listbox">
        <div class="list">
          <img class="font1" src="@/assets/images/font1.png" />
        </div>
        <div class="list">
          <img class="font2" src="@/assets/images/font2.png" />
        </div>
        <div class="list">
          <img class="font3" src="@/assets/images/font3.png" />
        </div>
        <div class="list">
          <img class="font4" src="@/assets/images/font4.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bannerForm',
  components: {
    Form: () => import('./Form.vue'),
  },
  props: {
    submitText: String,
    showForm: Boolean,
    video: String,
    text: String,
    bannerTabbox: Boolean,
    viedoFlag: Boolean,
    setHeight: String,
    logoSrc: {
      // logo图片
      type: String,
      default: '',
    },
    pcBgImg: {
      // banner背景图
      type: String,
      default: '',
    },
    title: {
      // 标题
      type: String,
      default: '合法可靠的电子印章',
    },
    desc: {
      // banner上的描述
      type: String,
      default: '浙江省“最多跑一次”电子签指定供应商',
    },

    firstLine: {
      // banner上的第一行标题
      type: String,
      default: '合法可靠的电子印章',
    },
    secondLine: {
      // banner上的第二行标题
      type: String,
      default: '电子合同平台',
    },

    landingPageName: {
      type: String,
      default: '',
    },
    hasApi: { // 是否是semapi落地页
      type: Boolean,
      default: false,
    }
  },
  methods: {
    setShowSuccessDialog(v) {
      this.$emit('setShowSuccessDialog', v)
    },
  },
}
</script>

<style lang="less" scoped>
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
.banner-form {
  width: 100%;
  position: relative;
  overflow: hidden;
  .viedo {
    width: 100%;
    height: 620px;
    background: rgba(0, 0, 0, 0.5);
    z-index: -1;
    .basisDisplay(center, center);
    video {
      width: 100%;
      min-height: 620px;
      object-fit: fill;
      z-index: -2;
      display: inline-block;
      vertical-align: baseline;
    }
  }

  .content {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: 0 auto;
    max-width: 1320px;
    height: 100%;
    .basisDisplay(space-around, center);
    .content-left {
      color: #fff;
    }
  }
  .banner_tabbox {
    width: 100%;
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    bottom: 0;
    .tab_listbox {
      display: flex;
      .basisDisplay(center, center);
      .list {
        width: 350px;
        height: 100px;
        .basisDisplay(center, center);
      }
      .list:nth-child(1) {
        background: #333;
        opacity: 0.67;
        img {
          width: 243px;
          height: 19px;
        }
      }
      .list:nth-child(2) {
        background: #000;
        opacity: 0.8;
        img {
          width: 212px;
          height: 19px;
        }
      }
      .list:nth-child(3) {
        background: #333;
        opacity: 0.67;

        img {
          width: 150px;
          height: 55px;
        }
      }
      .list:nth-child(4) {
        background: #000;
        opacity: 0.8;
        img {
          width: 185px;
          height: 52px;
        }
      }
    }
  }
}
</style>
